import { useState, useEffect } from "react";
import {
  Grid,
} from "@mui/material";
import { useForm } from "react-hook-form";
import MDButton from "components/MDButton";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SelectFields } from "ui-components/Form";
import { InboundHeaderCard } from "ui-components/Layout";
import { Success, Error_, LoadingDialog } from "ui-components/Alert";
import { useCustomerValue } from "providers/CustomerContext";
import { createSKUPackType } from "services/data.internal.service";
import { getactivecustomercode,addNewBillingList,editBillingList,getcustomerbillingconfiguration,getdefaultbillingconfiguration ,
  copyCustomerBillingConfiguration,getbillingconfigurationbybillingno} from "services/data.billing.service";
import { useVendorOptions, useSKUOptions } from "hooks/useQueryHook";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { StyledDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { AddButton, DeleteButton } from "ui-components/IconButton";
import { billingManagementFeesColumns } from "./columns";
import _ from "lodash";
import { Texts } from "ui-components/Form";

const palletTypeOptions = {
  SMALL: { label: "Small Pallet", value: "SMALL" },
  STANDARD: { label: "Standard Pallet", value: "STANDARD" },
  LARGE: { label: "Large Pallet", value: "LARGE" },
};

function ManagementFeesBillingReportConfiguration({ activeTab,billingname,setBillingname,billingNo,isEditMode,isEdited,  setIsEdited,onSubmit, viewPricePermission }) {
  const { customerCode } = useCustomerValue();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const location = useLocation();
  console.log('billingnameinsidestorage',billingname);
  const { skuCode = null } = location?.state ?? {};
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState({
    //...initialValues,
    customerCode,
    skuCode,
    upmBase: 1,
    packType: "01",
    palletType: palletTypeOptions["STANDARD"],
  });
  const queryClient = useQueryClient();
  const [vendorOptions, setVendorOptions] = useState([]);
  const [skuOptions, setSKUOptions] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const [list, setList] = useState([]);
  const [localData, setLocalData] = useState([]);
  const [isDefaultConfiguration, setIsDefaultConfiguration] = useState(false);
  console.log('billingnoinstoragebiillingreportconfiguration',billingNo);
  const createSKUPackTypeMutation = useMutation(createSKUPackType, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    //defaultValues: initialValues,
    values: formValues,
    //resolver: yupResolver(skuPackTypeValidation),
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [zoneObj, setZoneObj] = useState({});
  const [editing, setEditing] = useState(false);

  const [tableData, setTableData] = useState([]);

  const addBillingMutation = useMutation(addNewBillingList, {
    onSuccess: (data) => {
      console.log("Add Success:", data);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError: (error) => {
      console.error("Add Error:", error);
      setAlert(<Error_ data={error} onChange={setAlert} />);
    },
  });

  const editBillingMutation = useMutation(editBillingList, {
    onSuccess: (data) => {
      console.log("Add Success:", data);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError: (error) => {
      console.error("Add Error:", error);
      setAlert(<Error_ data={error} onChange={setAlert} />);
    },
  });

  const addnewbillingMutation = useMutation(
    (requestData) => addNewBillingList(requestData),
    {
      onSuccess: (data) => {
        console.log("Success:", data);
        setAlert(<Success data={data} onChange={setAlert} />);
      },
      onError: (error) => {
        console.error("Error:", error);
        setAlert(<Error_ data={error} onChange={setAlert} />);
      },
    }
  );
  
  const copyBillingConfigurations = async () => {
    try {
      setLoading(true);
      setIsDefaultConfiguration(true);
      console.log("customerCode:", customerCode);
      console.log("activeTab:", activeTab);
      if (selectedCustomer) {
        const customerValue = selectedCustomer.value;
        console.log("Customer Value:", customerValue);
        const response = await getcustomerbillingconfiguration({ customerValue,activeTab });
        const processedData = response.data.data.map((row) => ({
          ...row,
          customerCode: customerCode,
          active: row.status === "O" ? "Active" : "Inactive",
          rate: row.rate ? parseFloat(row.rate).toFixed(2) : "0.00"
        }));
        setIsDefaultConfiguration(true);
      console.log("run fetchBillingConfigurations");

      // Merge new rows into tableData
      setTableData((prev) => {
        const mergedData = [...processedData, ...prev.filter((row) => !row.id)];
        return mergedData;
      });

      setLocalData((prev) => {
        const mergedData = [...processedData, ...prev.filter((row) => !row.id)];
        return mergedData;
      });

      setLoading(false);
      } else {
        console.error("Selected customer is null or undefined.");
      }
      //const customerValue = selectedCustomer.value;
      
      
      console.log(processedData);

      
    } catch (err) {
      setError(err);
      setLoading(false);
      //setIsDefaultConfiguration(false);
    }
  };

  useEffect(() => {
    console.log("localData updated:", localData);
  }, [localData]);
  useEffect(() => {
    console.log("tableData updated:", tableData);
  }, [tableData]); // This useEffect will run every time tableData changes
  
  useEffect(() => {
    const fetchBillingConfigurations = async () => {
      try {
        setLoading(true);
        console.log("customerCode:", customerCode);
        console.log("activeTab:", activeTab);
        console.log("billingNo:", billingNo);
        let response="";
        let processedData="";
        if(!billingNo)
        {
          response = await getdefaultbillingconfiguration({ activeTab,billingname,customerCode });
          console.log("getdefaultbillingconfiguration");
          console.log(response);
          processedData = response.data.data.map((row) => ({
            ...row, 
            active: row.status === "O" ? "Active" : "Inactive",
            customerCode: customerCode,
            rate: row.rate ? parseFloat(row.rate).toFixed(2) : "0.00"
          }));
        }
        else if (billingNo)
        {
          response = await getbillingconfigurationbybillingno({ billingNo,activeTab });
          console.log(response);
          console.log("getbillingconfigurationbybillingno");
          processedData = response.data.data.map((row) => ({
            ...row, 
            customerCode: customerCode,
            active: row.status === "O" ? "Active" : "Inactive",
            rate: row.rate ? parseFloat(row.rate).toFixed(2) : "0.00"
          }));
        }
        else {
          console.warn("Unexpected case: No billingNo or activeTab provided");
        }
        
        setIsDefaultConfiguration(true);
        console.log('run useeffect');
        
        setLocalData((prev) => {
          const mergedData = [...processedData, ...prev.filter((row) => !row.id)];
          return mergedData;
        });
  
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        //setIsDefaultConfiguration(false);
      }
    };
  
    if (customerCode && activeTab) {
      fetchBillingConfigurations();
    }
  }, []);

  const handleProcessRowUpdate = (updatedRow) => {
    const updatedStatus = updatedRow.active === "Active" ? "O" : "C";
    const formattedRow = {
      ...updatedRow,
      rate: updatedRow.rate ? parseFloat(updatedRow.rate).toFixed(2) : "0.00",
      status: updatedStatus, // Update status column
    };

    setLocalData((prev) =>
      prev.map((row) =>
        row.id === formattedRow.id ? { ...row, ...formattedRow } : row
      )
    );
    setIsEdited(true);
    console.log('handleprocessrowupdate');
    return formattedRow;
  };

  useEffect(() => {
    if (onSubmit) {
      onSubmit(handleSubmit); // Pass handleSubmit function to parent
    }
  }, [onSubmit]);

  const handleSubmit = async () => {
    try {
      setIsEdited(false);
      window.scrollTo(0, 0);
      const validate = validateData(localData);
      if (validate.length > 0) {
        setAlert(<Error_ content={validate.join(",")} onChange={setAlert} />);
        return;
      }
      if (isDefaultConfiguration) {
        console.log("No records saved. Inserting all data...");
        console.log(localData);
        console.log(tableData);
  
        // Add the billingName column
        const updatedLocalData = localData.map((row) => ({
          ...row,
          billingname, // Add the billingName field
        }));
        console.log(updatedLocalData);
  
        // Call the API to add data
        if (isEditMode) {
          // Run edit mutation if in edit mode
          editBillingMutation.mutate(updatedLocalData, {
            onSuccess: (data) => {
              console.log("Edit Success:", data);
              setAlert(<Success data={data} onChange={setAlert} />);
            },
            onError: (error) => {
              console.error("Edit Error:", error);
              setAlert(<Error_ data={error} onChange={setAlert} />);
            },
          });
        } else {
          // Run add mutation if not in edit mode
          addBillingMutation.mutate(updatedLocalData, {
            onSuccess: (data) => {
              console.log("Add Success:", data);
              setAlert(<Success data={data} onChange={setAlert} />);
            },
            onError: (error) => {
              console.error("Add Error:", error);
              setAlert(<Error_ data={error} onChange={setAlert} />);
            },
          });
        }
  
        console.log("All rows inserted successfully!");
      } else {
        console.log("Records exist. Checking for modifications...");
  
        // Identify modified rows
        const updatedRows = localData.filter((row) =>
          tableData.some(
            (originalRow) => originalRow.id === row.id && !_.isEqual(originalRow, row)
          )
        );
  
        if (updatedRows.length > 0) {
          console.log("Updating modified rows:", updatedRows);
  
          await Promise.all(
            updatedRows.map(async (row) => {
              await updateRowAPI(row); // Replace with your actual API call for updating rows
            })
          );
  
          console.log("Modified rows updated successfully!");
        } else {
          console.log("No modifications detected. No updates made.");
        }
      }
  
      // Update the original table data after successful submission
      setTableData(localData);
    } catch (error) {
      console.error("Error saving changes:", error);
      setAlert(<Error_ data={error} onChange={setAlert} />);
    }
  };

  const mutation = useMutation(copyCustomerBillingConfiguration, {
    onSuccess: (data) => {
      console.log('Billing Configuration copied successfully:', data);
      setAlert(<Success data={data} onChange={setAlert} />);
      // You can show a success message here, or update the UI based on the successful mutation
    },
    onError: (error) => {
      console.error('Error copying billing configuration:', error);
      setAlert(<Error_ data={error} onChange={setAlert} />);
      // You can show an error message here
    },
  });

  const [selectedContent, setSelectedContent] = useState("perCbm");

  const {
    control,
    setValue,
    //handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = form;

  const { isFetching } = useQuery({
    queryFn: () => getactivecustomercode(),
    onSuccess: (data) => {
      const options = data.data.data.map((item) => ({
        label: item.customerCode, // Display label for each option
        value: item.customerCode, // Actual value of each option
      }));
      setCustomerOptions(options); // Update the state with formatted options
    },
    onError,
  });
 
  useVendorOptions({
    customerCode,
    onSuccess: (data) => {
      const vendors = data.data.data;

      setVendorOptions(vendors);
      if (vendors.length > 0) {
        setValue("vendorCode", vendors[0]);
      }
    },
    onError,
  });
  useSKUOptions({
    customerCode,
    onSuccess: (data) => setSKUOptions(data.data.data.map((x) => x.skuCode)),
  });

  const infoProps = {
    vendorOptions,
    skuOptions,
    control,
    errors,
    //formRender,
  };

  const createStatus = createSKUPackTypeMutation.status === "loading";
  const [ambientPrices, setAmbientPrices] = useState({
    daily: "",
    weekly: "",
    monthly: "",
  });
  const [aircondPrices, setAircondPrices] = useState({
    daily: "",
    weekly: "",
    monthly: "",
  });

  return (
    <><InboundHeaderCard lg={12}>
      {isFetching && <LoadingDialog title="Fetching Billing Setting" />}
      {createStatus && <LoadingDialog />}
      
      {alert}
      <form noValidate>
        {/* <FormTitle title={"PER CBM"} /> */}
        <br></br>

        <div>
    <Grid item xs={1.5}> <Texts
            field={{ name: "billingname",value:billingname, label: "Billing Name", maxLength: 50 }}
            onChange={(e) => {
              if (!isEditMode) {
                setBillingname(e.target.value);
              }
            }} disabled={isEditMode}
          /></Grid>
   <br></br>
          <Grid container spacing={1} alignItems="right" justifyContent="flex-end">
            <Grid item xs={1.5}>
              <SelectFields
                field={{
                  name: "customerCode",
                  label: "Customer Code",
                  value: selectedCustomer,
                  errors: {},
                }}
                options={customerOptions}
                onChange={(e, v) => {setSelectedCustomer(v);console.log("Selected value:", v)}} // Handle selection
              />
            </Grid>
            <Grid item xs={1.5}>
              <MDButton
                color="info"
                variant="gradient"
                onClick={copyBillingConfigurations}
              >
                Copy Setting From
              </MDButton>
            </Grid>
          </Grid>
        </div>
        <div>
          <br></br>
<StyledDataGrid
  columns={[
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: ({ row }) => [
      <AddButton
      title="Add"
      onClick={() => {
        setTableData((prev) => {
          // Find the index of the clicked row in the table data
          const rowIndex = prev.findIndex((item) => item.id === row.id);
    
          // Calculate a unique ID for the new row
          const nextId = prev.length > 0 ? Math.max(...prev.map((item) => item.id)) + 1 : 1;
    
          // Create the new row
          const newRow = {
            id: nextId, // Dynamically assigned ID
            unit: row.uom,
            chargeType: row.chargeType,
            customerCode: row.customerCode, // Copy from the clicked row
            category: row.category, // Copy from the clicked row
            billingParameter: row.billingParameter,
            criteria: row.criteria, // Copy the criteria from the clicked row
            active: "Active", // Default value
            billingName: null, // Default value
            billingNo: 0,
            createdBy: row.createdBy, // Keep the same or modify
            createdOn: new Date().toISOString(), // Set to the current timestamp
            lowerLimit: 0, // Default value
            rate: 0, // Default value
            status: "O", // Default status
            updatedBy: row.updatedBy, // Keep the same or modify
            updatedOn: new Date().toISOString(), // Set to the current timestamp
            upperLimit: 0, // Default value
          };
    
          console.log("New row:", newRow);
    
          // Insert the new row right below the clicked row
          const updatedData = [
            ...prev.slice(0, rowIndex + 1), // Rows before the clicked row
            newRow, // The new row
            ...prev.slice(rowIndex + 1), // Rows after the clicked row
          ];
          console.log("Updated table data:", updatedData);
          return updatedData;
        });
    
        setLocalData((prev) => {
          // Find the index of the clicked row in the local data
          const rowIndex = prev.findIndex((item) => item.id === row.id);
    
          // Calculate a unique ID for the new row
          const nextId = prev.length > 0 ? Math.max(...prev.map((item) => item.id)) + 1 : 1;
    
          // Create the new row
          const newRow = {
            id: nextId,
            customerCode: row.customerCode,
            category: row.category,
            billingParameter: row.billingParameter,
            criteria: row.criteria,
            chargeType: row.chargeType,
            active: "Active",
            billingName: row.billingName,
            billingNo: 0,
            createdBy: row.createdBy,
            createdOn: new Date().toISOString(),
            lowerLimit: 0,
            rate: row.rate,
            status: "O",
            unit: row.uom,
            uom:row.uom,
            updatedBy: row.updatedBy,
            updatedOn: new Date().toISOString(),
            upperLimit: 0,
          };
    
          console.log("New row (local):", newRow);
    
          // Insert the new row right below the clicked row
          const updatedData = [
            ...prev.slice(0, rowIndex + 1),
            newRow,
            ...prev.slice(rowIndex + 1),
          ];
          console.log("Updated local data:", updatedData);
          return updatedData;
        });

        setIsEdited(true);
      }}
    />,
    

    <DeleteButton
    title="Delete"
    onClick={() => {
      setTableData((prev) => {
        // Filter out the row with the matching id
        const updatedData = prev.filter((item) => item.id !== row.id);
        console.log("Updated table data after delete:", updatedData);
        return updatedData;
      });
  
      setLocalData((prev) => {
        // Filter out the row with the matching id in local data
        const updatedData = prev.filter((item) => item.id !== row.id);
        console.log("Updated local data after delete:", updatedData);
        return updatedData;
      });

      setIsEdited(true);
    }}
  />
  
      ],
    },
    ...billingManagementFeesColumns(zoneOptions, zoneObj, setEditing, viewPricePermission),
  ]}
  rows={localData}
  processRowUpdate={handleProcessRowUpdate}
  onProcessRowUpdateError={(error) => console.error("Error:", error)}
  disableRowSelectionOnClick
/>


        </div>
      </form>
      <br></br>
<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
  <MDButton color="info" variant="gradient" onClick={handleSubmit}>
    Save
  </MDButton>
</div>
</InboundHeaderCard>
     
    </>
  );
}

export default ManagementFeesBillingReportConfiguration;

export function validateData(data) {
  const {
    rate,
    innerpackUOM,
    upmInnerpack,
    caseUOM,
    upmCase,
    palletUOM,
    upmPallet,
    grossWeightUOM,
    upmGrossWeight,
    netWeightUOM,
    upmNetWeight,
    cubicUOM,
    upmCubic,
  } = data;
  let message = [];
  if (rate > 0 ) message.push("Invalid Rate");
  if (upmInnerpack > 0 && innerpackUOM === null) message.push("Invalid Inner Pack Measurement");
  if (upmCase > 0 && caseUOM === null) message.push("Invalid Case Measurement");
  if (upmPallet > 0 && palletUOM === null) message.push("Invalid Pallet Measurement");
  if (upmGrossWeight > 0 && grossWeightUOM === null)
    message.push("Invalid Gross Weight Measurement");
  if (upmNetWeight > 0 && netWeightUOM === null) message.push("Invalid Net Weight Measurement");
  if (upmCubic > 0 && cubicUOM === null) message.push("Invalid Cubic Measurement");

  if (upmInnerpack === 0 && innerpackUOM !== null) message.push("Invalid Inner Pack Measurement");
  if (upmCase === 0 && caseUOM !== null) message.push("Invalid Case Measurement");
  if (upmPallet === 0 && palletUOM !== null) message.push("Invalid Pallet Measurement");
  if (upmGrossWeight === 0 && grossWeightUOM !== null)
    message.push("Invalid Gross Weight Measurement");
  if (upmNetWeight === 0 && netWeightUOM !== null) message.push("Invalid Net Weight Measurement");
  if (upmCubic === 0 && cubicUOM !== null) message.push("Invalid Cubic Measurement");
 console.log("entering validation checking");
  return message;
}
